<template>
  <div class="desktopTopicOverlayContainer">
    <div v-for="(topic,index) in parsedData" :key="index" :class="'topicShadow '+(topic.isVisible?'active':'')">
        <div class="singleRow">
            <div class="cancelButton" @click="closeTopic(topic.Title)">Close(X)</div>
        </div>
        <div class="singleRow">
            <div class="textContainer" @click="buttonClick(topic)" :title="topic.Title" :style="'background:'+topic.color+';'">{{topic.Title}}</div>
            <div class="progressContainer">
                <div class="singleProgressContainer">
                  <div class="progressBar" :style="'background:'+topic.color+';width:'+topic.width+'%;left:'+topic.left+'%;'"></div>
                  <div class="progressCircle" @click="buttonClick(topic)" :style="'background:'+topic.color+';left:'+topic.left+'%;'"></div>
                  <div class="activeProgressBar" :style="'background:'+topic.color+';width:'+topic.activeWidth+'%;left:'+topic.left+'%;'"></div>
                </div>
            </div>
        </div>
        <div class="singleRow" v-for="(subTopic,index) in topic.subTopics" :key="index">
            <div class="textContainer" @click="buttonClick(subTopic.segments[0])" :title="subTopic.Title" :style="'background:'+subTopic.color+';'">{{subTopic.Title}}</div>
            <div class="progressContainer">
                <div class="singleProgressContainer" v-for="(segment,index) in subTopic.segments" :key="index">
                  <div class="progressBar" :style="'background:'+subTopic.color+';width:'+segment.width+'%;left:'+segment.left+'%;'+(segment.isActive?'animation:redAnimation 1s infinite;':'')"></div>
                  <div class="progressCircle" @click="buttonClick(segment)" :style="'background:'+subTopic.color+';left:'+segment.left+'%;'"></div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import "../scss/desktop-topic-content.css";
import timeMixin from '../mixins/timeMixin'
export default {
  props: {
    topicsData: {
      type: Array,
      required: true
    }
  },
  methods:{
    openTopic(topicTitle){
      let activeTopicIndex=this.parsedData.findIndex(x=>x.isVisible==true)
      if(activeTopicIndex!=-1){
        this.parsedData[activeTopicIndex].isVisible=false
      }
      let newTopicIndex=this.parsedData.findIndex(x=>x.Title==topicTitle)
      if(newTopicIndex == activeTopicIndex)
        this.parsedData[newTopicIndex].isVisible=false
      else
        this.parsedData[newTopicIndex].isVisible=true
    },
    closeTopic(topicTitle){
      let activeTopicIndex=this.parsedData.findIndex(x=>x.Title==topicTitle)
      this.parsedData[activeTopicIndex].isVisible=false
    },
    runMethods(time){
      for(var i=0;i<this.parsedData.length;i++){
        if(this.parsedData[i].parsedStart<time && this.parsedData[i].parsedEnd>time){
          this.parsedData[i].activeWidth=((time-this.parsedData[i].parsedStart)/(this.parsedData[i].parsedEnd-this.parsedData[i].parsedStart)*100).toFixed(2)
        }
        for(var j=0;j<this.parsedData[i].subTopics.length;j++){
          for(var k=0;k<this.parsedData[i].subTopics[j].segments.length;k++){
            if(this.parsedData[i].subTopics[j].segments[k].parsedStart<time && this.parsedData[i].subTopics[j].segments[k].parsedEnd>time){
              this.parsedData[i].subTopics[j].segments[k].isActive=true
            }
            else{
              this.parsedData[i].subTopics[j].segments[k].isActive=false
            }
          }
        }
      }
    },
    buttonClick(item){
      this.$root.$emit('seekVideo',item.parsedStart) 
      this.$root.$emit('playVideo') 
    }
  },
  created(){
  },
  watch:{
    topicsData: function(topicsData){
      this.parsedData =[]
      for(var i=0;i<topicsData.length;i++){
        let topicData={
          Title:topicsData[i].Title,
          left:0,
          width:100,
          activeWidth:0,
          subTopics:[],
          color:'#ccc',
          isVisible:false,
          parsedStart:this.convertHoursMinsSecsToSeconds(topicsData[i].start),
          parsedEnd:this.convertHoursMinsSecsToSeconds(topicsData[i].end),
        }
        let startTime=this.convertHoursMinsSecsToSeconds(topicsData[i].start)
        let endTime=this.convertHoursMinsSecsToSeconds(topicsData[i].end)
        let timeDifference=endTime-startTime
        for(var j=0;j<topicsData[i].subTopics.length;j++){
          let subTopicIndex=topicData.subTopics.findIndex(x=>x.Title==topicsData[i].subTopics[j].Title)
          if(subTopicIndex==-1){
            topicData.subTopics.push({
              Title:topicsData[i].subTopics[j].Title,
              segments:[{
                left:((this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].start)-startTime)/timeDifference*100).toFixed(2),
                width:((this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].end)-this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].start))/timeDifference*100).toFixed(2),
                activeWidth:0,
                parsedStart:this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].start),
                parsedEnd:this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].end),
                isActive:false
              }],
              color:this.colors[j<this.colors.length?j:this.colors.length-1]
            })
          }
          else{
            topicData.subTopics[subTopicIndex].segments.push({
                left:((this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].start)-startTime)/timeDifference*100).toFixed(2),
                width:((this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].end)-this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].start))/timeDifference*100).toFixed(2),
                parsedStart:this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].start),
                parsedEnd:this.convertHoursMinsSecsToSeconds(topicsData[i].subTopics[j].end),
                isActive:false
            })
          }
        }
        this.parsedData.push(topicData)
      }
    }
  },
  data(){
    return{
      parsedData:[],
      colors:[
        '#2F7BC4',
        '#5C7194',
        '#EAC642',
        '#a792f1',
        '#eb94e3',
        '#eaff8c',
      ]
    }
  },
  mixins:[timeMixin]

};
</script>

<style>
</style>
